import type { BusinessParameterInfo } from '../hooks';

interface BusinessRequirementsProps {
  parameter: BusinessParameterInfo;
}

export function BusinessRequirements({ parameter }: BusinessRequirementsProps) {
  const { requirements } = parameter;

  return (
    <div className="space-y-2 text-sm">
      <h4 className="font-medium">Requirements</h4>
      <div className="grid grid-cols-2 gap-2">
        {requirements.jion > 0 && (
          <div className="flex justify-between">
            <span className="text-muted-foreground">Jion</span>
            <span>{requirements.jion}</span>
          </div>
        )}
        {requirements.freshWater > 0 && (
          <div className="flex justify-between">
            <span className="text-muted-foreground">Fresh Water</span>
            <span>{requirements.freshWater}</span>
          </div>
        )}
        {requirements.cogsValue > 0 && (
          <div className="flex justify-between">
            <span className="text-muted-foreground">COGS Value</span>
            <span>{requirements.cogsValue} H</span>
          </div>
        )}
        {requirements.foodValue > 0 && (
          <div className="flex justify-between">
            <span className="text-muted-foreground">Food Value</span>
            <span>{requirements.foodValue} H</span>
          </div>
        )}
      </div>
      {Object.keys(requirements.components).length > 0 && (
        <div>
          <span className="text-muted-foreground text-xs">Components:</span>
          <div className="grid grid-cols-2 gap-1 mt-1">
            {Object.entries(requirements.components).map(([name, qty]) => (
              <div key={name} className="flex justify-between text-xs">
                <span className="text-muted-foreground">{name}</span>
                <span>{qty}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
